import * as R from 'ramda'

export function findInCollection(predicate, collection) {

  if(!collection) return undefined

  var allKeys = R.keys(collection)
  for (let key in allKeys){
    if(predicate(collection[allKeys[key]])) return collection[allKeys[key]]
  }
  return undefined
}



// WEBPACK FOOTER //
// ./src/utils/search.js